import { LoadingModule } from '../loading/loading.module';
import { NgModule,NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import {CommonModule} from '@angular/common';
import { CollaboratorsDetailsComponent } from './collaborators-details.component';
import { collaboratorsDetailsRoutingoModule } from './collaborators-details-routing.module';
@NgModule({
  imports: [
    collaboratorsDetailsRoutingoModule,
    HttpClientModule,
    CommonModule,
    LoadingModule
  ],
  declarations: [CollaboratorsDetailsComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class collaboratorsDetailsModule { }
